<!-- eslint-disable no-tabs -->
<template>
  <div class="panel-notification">
    <div>
      <div class="panel-list metrics-group">
        <div class="d-flex" style="justify-content: space-between;">
          <h4 class="mb-15 ml-15 text-lowercase text-md">
            Events
          </h4>
          <div>
            <Button size="mini" @click="previousStep()">
              <span>BACK</span>
            </Button>
            <Button type="primary" size="mini" @click="nextStep()">
              <span>NEXT</span>
            </Button>
          </div>
        </div>
        <ul>
          <li v-for="(event) in workflow.events" :key="event.key" class="metrics-box pointer"
            :style="{ 'border-left': '2px solid ' + event.color }" :class="{ 'metrics-box-active': event.isSelected }"
            @click="selectItem(event)">
            <div class="d-flex" style="justify-content: space-between;">
              <Checkbox v-model="event.isSelected" :label="event.name" :disabled="event.mandatory">
                <span style="color: black;">{{ event.name }}</span>
              </Checkbox>
              <div>
                <span v-if="event.sec_status_id" v-bind:class="getStatus(event.sec_status_id)">
                  <span class="order-status-button">
                    {{ $t(statusName(event.sec_status_id))}}
                  </span>
                  <span style="padding-left: 2px; padding-right: 2px;"> / </span>
                </span>
                <span v-bind:class="getStatus(event.status_id)">
                  <span class="order-status-button">
                    {{$t(statusName(event.status_id))}}
                  </span>
                </span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import NoData from '@common/asset/images/status-no-data.png';
// eslint-disable-next-line import/no-extraneous-dependencies
import LoaderCommon from '@common/asset/images/loader-common.gif';


import { transactionTypes } from '@/constants/integrations';

export default {
  props: {
    data: {
      type: Object,
    },
    workflow: {
      type: Object,
    },
  },
  data() {
    return {
      selectedItem: {},
      NoData,
      LoaderCommon,
      transactionTypes,
      metricsGroup: [],
      events: [],
    };
  },
  created() {
    this.getMetricsData();
    // this.selectedItem = this.metricsGroup[0].metrics[0];
  },
  computed: {
    isSelectedLog() {
      console.log('this.selectedItem.id === ', this.selectedItem.id);
      return (id => !!((this.selectedItem && this.selectedItem.id) === id));
    },
  },
  methods: {
    loadMore() {
      this.$emit('load-more');
    },
    previousStep() {
      this.$emit('previous-step');
    },
    nextStep() {
      this.$emit('next-step', { events: this.events });
    },
    selectItem(event) {
      if (!event.mandatory) {
        event.isSelected = !event.isSelected;
      }
    },
    getStatus(id) {
      return `order-status-${this.$statusUtil.getMainStatusName(id)}`;
    },
    statusName(id) {
      const mainStatus = this.$statusUtil.mainStatus;
      const mainStatusId = this.$statusUtil.getMainStatusId(id);
      return mainStatus.find(status => status.id === mainStatusId) &&
        mainStatus.find(status => status.id === mainStatusId).tlabel;
    },
    getRandomColor() {
      const hue = Math.floor(Math.random() * 360); // Full color spectrum
      const saturation = Math.floor(Math.random() * 20) + 60; // 60%–80% saturation
      const lightness = Math.floor(Math.random() * 20) + 30; // 30%–50% lightness (medium-dark)
      return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
    },
    getMetricsData() {
      this.events = [
        {
          key: 'INDENT_CREATION',
          name: 'Indent Creation',
          status_id: 0, // Indented
          mandatory: true,
          isSelected: true,
        },
        {
          key: 'VEHICLE_ASSIGNMENT',
          name: 'Vehicle assignment',
          status_id: 4, // Assigned
          isSelected: false,
        },
        {
          key: 'BOOKING_CONFIRMATION',
          name: 'Booking Confirmation',
          isSelected: false,
        },
        {
          key: 'REPORTED',
          name: 'Reported',
          isSelected: false,
        },
        {
          key: 'TRUCK_IN',
          name: 'Truck In',
          status_id: 5, // Arrived
          isSelected: false,
        },
        {
          key: 'REACHED_LOADING_POINT',
          name: 'Reached Loading Point',
          isSelected: false,
        },
        {
          key: 'START_LOAD',
          name: 'Start Load',
          isSelected: false,
        },
        {
          key: 'END_LOAD',
          name: 'End Load',
          isSelected: false,
        },
        {
          key: 'TRUCK_OUT',
          name: 'Truck Out',
          status_id: 6, // Dispatched
          isSelected: false,
        },
        {
          key: 'MARK_DELIVER',
          name: 'Mark Deliver',
          status_id: 7, // Delivered
          sec_status_id: 23, // Delivery Pending
          mandatory: true,
          isSelected: true,
        },
// {
//   key: 'GRN',
//   name: 'GRN',
//   status_id: 7, // Dispatched
        //   isSelected: false,
        // },
      ];
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@common/styles-shipper/settings";

.panel-notification {
  width: 60%;
}

.panel-notification .metrics-box {
  background-color: rgba(255, 255, 255, 0.75);
  font-size: 1.2rem;
  color: #404040;
  border-bottom: 1px solid #E9F1F5;
  margin-left: 10px;
  margin-top: 10px;
  padding: 20px;
  border-radius: 5px;
  /* border-left: 4px solid #3F6ABF; */
}

.metrics-box li {
  min-width: 109px;
  height: 70px;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding: 14px 10px 10px 10px;
  position: relative;
  cursor: pointer;
}

.metrics-box p {
  margin: 0;
  font: 1.2rem / 14px "OpenSans-Semibold";
  /* color: #24242f; */
  text-transform: capitalize;
  /* margin-bottom: 5px; */
}

.metrics-box-active {
  background: linear-gradient(0deg, rgba(0, 118, 221, 0.1), rgba(0, 118, 221, 0.1)) !important;
}

.metrics-box .text-value {
  background: linear-gradient(360deg, #18283B -62%, #3F6ABF 104%);
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: rgba(0, 0, 0, 0) !important;
  font: 2.2rem / 20px "OpenSans-Bold";
}

.panel-box {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin: 0;
  position: relative;
  z-index: 0;
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
}

.metrics-group {
  /* background-color: rgba(255, 255, 255, 0.75); */
  -webkit-backdrop-filter: blur(6px);
  backdrop-filter: blur(6px);
  padding: 10px;
  display: -ms-flexbox;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  font-size: 1.2rem;
  color: #404040;
  border: 1px solid #E9F1F5;
  margin-bottom: 10px;
}

.order {
  &-status-button {
    margin-top: -10px;
    padding: 2px 5px 2px 5px;
    border-radius: 2px;
    border-top-right-radius: 2px;
    border-bottom-right-radius: 0px;
    font-family: $fontSemibold;
    text-transform: uppercase;
    width: fit-content;
    height: 20px;

    &_ps {
      padding: 4px 5px 3px;
      border-radius: 2px;
      margin-left: -6px;
      margin-right: -6px;
      text-align: center;

      .el-tooltip {
        background: transparent;
        border: transparent;
      }

      .svg-fill {
        margin-top: 0px;
      }
    }
  }

  &-item {
    margin-bottom: 10px;
    box-shadow: 0 2px 4px 0 #ECECEC;

    .order-row {
      width: 100%;
      padding: 0 10px 0 30px;
      background: #fff;

      //display: flex;
      &:hover {
        background-color: #eff3f5;
      }

      &.overdue {
        /*background: rgba(255, 0, 0, 0.1);*/
      }
    }

    .order-col {
      display: flex;
      align-items: center;
      padding: 10px 10px 10px 0px;
      font-family: $fontSemibold;
      color: #404040;
    }

    .order-details {
      position: relative;
      padding: 16px;
      background: #fff;
      border-top: 1px solid #F0F0F0;
    }
  }

  &-input-title {
    @extend %normal;
    color: $sec-text;
    font-size: 1.2rem;
    text-transform: uppercase;
  }

  &-input-value {
    font-family: $fontSemibold;
    color: $sec-text;
    border-bottom: 1px solid #DEE5E6;
    font-size: 1.2rem;
    padding: 10px 0 5px;
  }

  &-status {
    &-indented {
      .order-status-button {
        border: 1px solid rgba(237, 226, 254, 0.7);
        background-color: rgba(237, 226, 254, 0.7);
        color: $intented;

        &_ps {
          background-color: rgba(237, 226, 254, 0.3);
          color: $intented;

          .svg-fill {
            fill: $intented;
          }
        }
      }
    }

    &-pending {
      .order-status-button {
        border: 1px solid #B2EBF2;
        background-color: #B2EBF2;
        color: $intented;

        &_ps {
          background-color: rgba(#B2EBF2, 0.5);
          color: $intented;

          .svg-fill {
            fill: $intented;
          }
        }
      }
    }

    &-truck_assigned {
      .order-status-button {
        border: 1px solid rgba(255, 220, 229, 0.7);
        background-color: rgba(255, 220, 229, 0.7);
        color: $assigned;

        &_ps {
          background-color: rgba(255, 220, 229, 0.3);
          color: $assigned;

          .svg-fill {
            fill: $assigned;
          }
        }
      }
    }

    &-truck_arrived {
      .order-status-button {
        border: 1px solid rgba(178, 235, 242, 0.7);
        background-color: rgba(178, 235, 242, 0.7);
        color: $arrived;

        &_ps {
          background-color: rgba(178, 235, 242, 0.3);
          color: $arrived;

          .svg-fill {
            fill: $arrived;
          }
        }
      }
    }

    &-shipped {
      .order-status-button {
        border: 1px solid rgba(207, 223, 255, 0.7);
        background-color: rgba(207, 223, 255, 0.7);
        color: $dispatched;

        &_ps {
          background-color: rgba(207, 223, 255, 0.3);
          color: $dispatched;

          .svg-fill {
            fill: $dispatched;
          }
        }
      }
    }

    &-ship_ready {
      .order-status-button {
        border: 1px solid rgba(178, 235, 242, 0.7);
        ;
        background-color: rgba(178, 235, 242, 0.7);
        ;
        color: $arrived;

        &_ps {
          background-color: rgba(178, 235, 242, 0.3);
          color: $arrived;

          .svg-fill {
            fill: $arrived;
          }
        }
      }
    }

    &-re_ship {
      .order-status-button {
        border: 1px solid rgba(231, 231, 231, 0.7);
        ;
        background-color: rgba(231, 231, 231, 0.7);
        ;
        color: $arrived;

        &_ps {
          background-color: rgba(231, 231, 231, 0.3);
          color: $arrived;

          .svg-fill {
            fill: $arrived;
          }
        }
      }
    }

    &-re_ship_processing {
      .order-status-button {
        border: 1px solid rgba(231, 231, 231, 0.7);
        ;
        background-color: rgba(231, 231, 231, 0.7);
        ;
        color: $arrived;

        &_ps {
          background-color: rgba(231, 231, 231, 0.3);
          color: $arrived;

          .svg-fill {
            fill: $arrived;
          }
        }
      }
    }

    &-dispatched {
      .order-status-button {
        border: 1px solid rgba(207, 223, 255, 0.7);
        background-color: rgba(207, 223, 255, 0.7);
        color: $dispatched;

        &_ps {
          background-color: rgba(207, 223, 255, 0.3);
          color: $dispatched;

          .svg-fill {
            fill: $dispatched;
          }
        }
      }
    }

    &-delivered {
      .order-status-button {
        border: 1px solid rgba(208, 247, 197, 0.7);
        background-color: rgba(208, 247, 197, 0.7);
        color: $delivered;

        &_ps {
          background-color: rgba(208, 247, 197, 0.3);
          color: $delivered;

          .svg-fill {
            fill: $delivered;
          }
        }
      }
    }

    &-delivery_pending {
      .order-status-button {
        border: 1px solid rgba(208, 247, 197, 0.7);
        background-color: rgba(208, 247, 197, 0.7);
        color: $delivery_pending;

        &_ps {
          background-color: rgba(208, 247, 197, 0.3);
          color: $delivery_pending;

          .svg-fill {
            fill: $delivery_pending;
          }
        }
      }
    }

    &-cancelled {
      .order-status-button {
        border: 1px solid rgba(255, 230, 234, 0.7);
        background-color: rgba(255, 230, 234, 0.7);
        color: $canceled;

        &_ps {
          background-color: rgba(255, 230, 234, 0.3);
          color: $canceled;

          .svg-fill {
            fill: $canceled;
          }
        }
      }
    }

    &-optima_suggested {
      .order-status-button {
        border: 1px solid rgba(255, 230, 234, 0.7);
        background-color: rgba(255, 230, 234, 0.7);
        color: $canceled;

        &_ps {
          background-color: rgba(255, 230, 234, 0.3);
          color: $canceled;

          .svg-fill {
            fill: $canceled;
          }
        }
      }
    }

    &-re_ship_error {
      .order-status-button {
        border: 1px solid rgba(255, 230, 234, 0.7);
        background-color: rgba(255, 230, 234, 0.7);
        color: $canceled;

        &_ps {
          background-color: rgba(255, 230, 234, 0.3);
          color: $canceled;

          .svg-fill {
            fill: $canceled;
          }
        }
      }
    }

    &-requested {
      .order-status-button {
        border: 1px solid rgba(255, 240, 203, 0.7);
        background-color: rgba(255, 240, 203, 0.7);
        color: $requested;

        &_ps {
          background-color: rgba(255, 240, 203, 0.3);
          color: $requested;

          .svg-fill {
            fill: $requested;
          }
        }
      }
    }

    &-container_picked {
      .order-status-button {
        border: 1px solid rgba(178, 235, 242, 0.7);
        background-color: rgba(178, 235, 242, 0.7);
        color: $arrived;

        &_ps {
          background-color: rgba(178, 235, 242, 0.3);
          color: $arrived;

          .svg-fill {
            fill: $arrived;
          }
        }
      }
    }

    &-drafted {
      .order-status-button {
        border: 1px solid rgba(231, 231, 231, 0.3);
        background-color: rgba(231, 231, 231, 1);
        color: $drafted;

        &_ps {
          background-color: rgba(231, 231, 231, 0.3);
          color: $drafted;

          .svg-fill {
            fill: $drafted;
          }
        }
      }
    }
  }
}
</style>
